import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { CacheService } from './cache.service';
import { Observable } from 'rxjs';
import { PendChangesAgg, IChangesListInq, ChangesListResult, ListInq, ChangeDetailList, ChgApproval } from '../models/Approvals';
import { ChangeContext } from '../models/EvoSalesPortalModel';

@Injectable()
export class ApprovalsService {
	controller = 'api/Approvals/';

	constructor(private http: HttpClient, private cacheService: CacheService) { }

	public getPendingApprovalAggregate(
		lstInq: ListInq
	): Observable<PendChangesAgg> {
		const url = this.controller + 'GetPendingApprovalAggregate';
		const body = this.cacheService.stringify(lstInq);

		return this.http.post<PendChangesAgg>(url, body, {
			headers: new HttpHeaders().set(
				'Content-Type',
				'application/json'
			)
		});
	}

	public getChangesListBySalesEntity(
		inquiry: IChangesListInq
	): Observable<ChangesListResult> {
		const url = this.controller + 'GetChangesListBySalesEntity';
		const body = this.cacheService.stringify(inquiry);
		console.log(body);
		return this.http.post<ChangesListResult>(url, body, {
			headers: new HttpHeaders().set(
				'Content-Type',
				'application/json'
			)
		});
	}

	public putPendingChangesApprove(
		pca: ChgApproval
	): Observable<string> {
		const url = this.controller + 'PutPendingChangesApprove';
		const body = this.cacheService.stringify(pca);
		return this.http.post<string>(url, body, {
			headers: new HttpHeaders().set(
				'Content-Type',
				'application/json'
			)
		});
	}

	public GetDeclinedAggregate(
		inquiry: IChangesListInq
	): Observable<ChangesListResult> {
		const url = this.controller + 'GetDeclinedAggregate';
		const body = this.cacheService.stringify(inquiry);
		console.log(body);
		return this.http.post<ChangesListResult>(url, body, {
			headers: new HttpHeaders().set(
				'Content-Type',
				'application/json'
			)
		});
	}

	public getChangeDetailByChangeID(
		changeID: number
	): Observable<Array<ChangeDetailList>> {
		const url = this.controller + 'GetChangeDetailByChangeID?changeID=' + changeID.toString();
		return this.http.get<Array<ChangeDetailList>>(url);
	}

	public GetChangeContext(
		changeID: number
	): Promise<Array<ChangeContext>> {
		const url = this.controller + 'GetChangeContext/' + changeID.toString();
		return this.http.get<Array<ChangeContext>>(url).toPromise();
	}

	public GetDate(dt: any): Date {
		let dtFormatted: Date = null;
		try {
			const dtString = dt.month.toString() + '/' + dt.day.toString() + '/' + dt.year.toString();
			dtFormatted = new Date(dtString);
		} catch {
			dtFormatted = null;
		}
		return dtFormatted;
	}
}
